import React from 'react';
import PropTypes from 'prop-types';
import {
  FeatureDrawerActions,
  FeatureDrawerContent,
} from '../../../../knock-design-system';

export const CloneProperty = ({ handleDrawerMode }) => {
  return (
    <React.Fragment>
      <FeatureDrawerContent>Cloning a property</FeatureDrawerContent>
      <FeatureDrawerActions
        closeDrawer={handleDrawerMode(null)}
        primaryButtonText="Apply"
        secondaryButtonText="Cancel"
      />
    </React.Fragment>
  );
};

CloneProperty.propTypes = {
  handleDrawerMode: PropTypes.func,
};
